export const DataFields = (t) => {
    return [
      {
        name: "",
        fields: [
          {
            id: "name",
            name: t('builder_subcategories_form_name'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showName",
            name: t('builder_subcategories_form_show_name'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "description",
            name: t('builder_subcategories_form_description'),
            type: "text",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "footer",
            name: t('builder_subcategories_form_footer'),
            type: "text",
            required: false,
            defaultValue: "",
            size: "small"
          },
          {
            id: "image",
            name: t('builder_subcategories_form_image'),
            type: "image",
            required: false,
            isImage: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "showImage",
            name: t('builder_subcategories_form_show_image'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
          {
            id: "presentation",
            name: t('builder_subcategories_form_presentation'),
            type: "select",
            containerOptions: "presentations",
            required: true,
            defaultValue: "",
            size: "small"
          },
          {
            id: "active",
            name: t('builder_subcategories_form_active'),
            type: "switch",
            required: true,
            defaultValue: false,
            size: "small"
          },
        ]
      }
    ]
  }